$(() => {
  const spaceFinderOptions = {
    valueNames: ['noise', 'building', 'description'],
  };

  const spaceFinderList = new List('space-finder', spaceFinderOptions);
  const $filterControls = $('#space-filters').find('button');
  const $sortControls = $('#space-sorters').find('a');

  const noItems = $('<div class="alert alert-warning">No Results. Try a different filter options.</div>');

  $filterControls.on('click', function () {
    const $this = $(this);
    const which = $(this).data('controls');
    const getValue = $this.data('value');

    $this.siblings()
      .removeClass('active')
      .end()
      .addClass('active');
    spaceFinderList.search(getValue, [which]);
  });

  $sortControls.on('click', function () {
    const $this = $(this);
    const sorter = $this.data('sort');
    spaceFinderList.sort(sorter);
  });

  spaceFinderList.on('updated', (list) => {
    if (list.matchingItems.length === 0) {
      $(list.list).append(noItems);
    } else {
      noItems.detach();
    }
  });
});
